import i18next from "i18next";

import { initReactI18next } from "react-i18next";
import HTTPApi from "i18next-http-backend";
import { supportedLanguagesConfig } from "utils/languages";

i18next
  .use(initReactI18next)
  .use(HTTPApi)
  .init({
    fallbackLng: "en",
    debug: false,
    returnObjects: true,
    supportedLngs: Object.keys(supportedLanguagesConfig),
    interpolation: {
      escapeValue: false,
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["b", "br", "strong", "a", "span"],
    },
  });

export default i18next;
